module.exports = __webpack_public_path__ + "static/media/YB5F13_2.4261f393.jpg";